import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import Reactris from './reactris'

const root = ReactDOM.createRoot(document.querySelector('.reactris'))
root.render(<Reactris />)
